import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, Box } from "@mui/material";
import loadergif from "./loader.gif";
import { useAppSelector } from "@application/store/useStore";
const Loader = () => {
    const { isLoading } = useAppSelector((state) => state.loading);
    return isLoading ? (_jsx(Backdrop, { open: true, sx: {
            color: "#fff",
            zIndex: 7000,
            backdropFilter: "blur(20px)",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
        }, children: _jsx(Box, { component: "img", src: loadergif, alt: "Loading...", sx: { width: { xs: 300, sm: 400, md: "30%" }, height: "auto" } }) })) : null;
};
export default Loader;
